import buttons from 'src/lib/ui/config/buttons';

const closeButtonRightOffset = 10;

export const match2CloseButtonY = 11;

export function getMatch2CloseButtonX(
  width: number,
  buttonWidth = buttons.close.width,
) {
  return width + closeButtonRightOffset - buttonWidth * 0.5;
}
